<div
  class="transaction-receipt-preview"
  [ngClass]="{ 'pdf-preview': isPdf() }">
  <div class="receipt-preview-container">
    <div class="receipt-preview-header">
      <div class="receipt-preview-title">Receipt</div>
      <button
        id="receiptPreviewCloseBtn"
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="onClose()"></button>
    </div>

    <!-- Image container with scrolling -->
    @if (isImage()) {
      <app-image-viewer [url]="conditionalEnvReceiptUrl()"></app-image-viewer>
    }

    @if (isPdf()) {
      <app-pdf-viewer [url]="conditionalEnvReceiptUrl()"></app-pdf-viewer>
    }
  </div>
</div>
